module.exports = __webpack_public_path__ + "/images/cover-multi-ext-share.f48c43c.png";